<template>
  <!-- NOTE (TEMPLATE) to register a new proposal -->

  <div class="animated fadeIn">
    <b-card
      v-if="$router.currentRoute.path == '/researcher/newProposal'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <!-- loading component -->
      <Loading />
      <b-tabs class="mb-3" pills vertical v-model="tabIndex">
        <div class="d-flex justify-content-center mt-3"></div>
        <b-tab :title="'عنوان و حمایت‌های پیشین'" active>
          <b-form-group>
            <div class="d-flex" dir="ltr">
              <label
                for="switch_1"
                :class="
                  initial.initialObligation
                    ? 'ml-3 mb-0 done'
                    : 'ml-3 mb-0 required'
                "
              >
                اینجانب تعهد می کنم با مطالعه و آگاهی از
                <b-button
                  id="downLoad"
                  title="دانلود تعهدات"
                  variant="link"
                  :href="
                    filePath +
                    `/setad/private/15958532032483*H1%20'D9ED%20-E'%EF%BF%BD*%20'2%2071-G'%EF%BF%BD%20*-B%EF%BF%BDB'*%EF%BF%BD%20.pdf`
                  "
                >
                  <b-tooltip
                    placement="bottomleft"
                    target="downLoad"
                    triggers="hover"
                    variant="info"
                    >دانلود شیوه‌نامه</b-tooltip
                  >شیوه‌نامه حمایت از طرح‌های پژوهشی ستاد توسعه زیست فناوری </b-button
                >و طرح تقسیم کار ملی زیست‌فناوری نسبت به ارسال درخواست در سامانه
                اقدام می نمایم
              </label>
              <b-form-checkbox
                id="switch_1"
                v-model="initial.initialObligation"
              ></b-form-checkbox>
            </div>
          </b-form-group>
          <hr />
          <h3 class="text-primary mb-4">پژوهشگر گرامی</h3>
          <p>
            به ابزار ثبت طرح سامانه تقسیم کار ملی خوش آمدید. خواهشندیم ابتدا به
            سوالات زیر پاسخ دهید:
          </p>
          <b-form-group
            label="لطفا عنوان پیشنهادی طرح را به زبان فارسی بنویسید"
            :class="initial.faSubject ? 'done' : 'required'"
          >
            <b-form-input
              trim
              type="text"
              v-model="initial.faSubject"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها استفاده کرده است؟"
            :class="initial.initialIsSupported !== null ? 'done' : 'required'"
          >
            <b-form-radio-group v-model="initial.initialIsSupported">
              <b-form-radio :value="true">بله</b-form-radio>
              <b-form-radio :value="false">خیر</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
          <b-form-group
            label="حمایت ها:"
            v-if="initial.initialIsSupported"
            :class="initial.initialSupportedType ? 'done' : 'required'"
          >
            <b-form-select
              class="myselect2"
              id="first"
              v-model="initial.initialSupportedType"
              :options="options"
            >
            </b-form-select>
          </b-form-group>
          <b-form-group
            label="عنوان حمایت دریافتی"
            v-if="
              initial.initialSupportedType == 'other' &&
              initial.initialIsSupported
            "
            :class="initial.otherSupport ? 'done' : 'required'"
          >
            <b-form-input trim type="text" v-model="initial.otherSupport">
            </b-form-input>
          </b-form-group>
          <b-form-group
            label="توضیحات حمایت دریافتی:"
            v-if="initial.initialIsSupported"
            :class="initial.description ? 'done' : 'required'"
          >
            <b-form-textarea trim rows="6" v-model="initial.description">
            </b-form-textarea>
          </b-form-group>
        </b-tab>
        <b-tab disabled :title="'اطلاعات اصلی طرح'"></b-tab>
        <b-tab disabled :title="'مجری طرح'"></b-tab>
        <b-tab disabled :title="'همکاران طرح'"></b-tab>
        <b-tab disabled :title="'مشخصات طرح'"></b-tab>
        <b-tab disabled :title="'اطلاعات تجاری‌سازی'"></b-tab>
        <b-tab disabled :title="'زمان‌بندی'"></b-tab>
        <b-tab disabled :title="'هزینه‌ها'"></b-tab>
        <b-tab :title="'داوران پیشنهادی'" disabled></b-tab>
        <b-tab :title="'فایل‌های تکمیلی'" disabled></b-tab>
        <b-tab :title="'گام دهم: تعهدات'" disabled></b-tab>
        <b-tab disabled :title="'مرور نهایی و ارسال طرح'"></b-tab>
      </b-tabs>
      <div class="d-flex justify-content-center mt-3">
        <!-- NOTE (b-start) To begin the proposal registration process -->
        <b-button
          class="mx-1"
          variant="primary"
          @click="start()"
          :disabled="
            !initial.initialObligation ||
            !initial.faSubject ||
            initial.initialIsSupported === null ||
            (initial.initialIsSupported && !initial.initialSupportedType) ||
            (initial.initialIsSupported && !initial.description) ||
            (initial.initialIsSupported &&
              initial.initialSupportedType == 'other' &&
              !initial.otherSupport)
          "
          >آغاز فرآیند ثبت طرح</b-button
        >
      </div>
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      initial: {
        initialIsSupported: null,
      },
      tabIndex: 1,
      options: [
        { text: "طرح", value: "project" },
        { text: "پایان‌نامه ارشد", value: "master" },
        { text: "رساله دکتری", value: "phd" },
        { text: "مقالات", value: "article" },
        { text: "نشست‌ها", value: "meeting" },
        { text: "دوره‌های پسادکتری", value: "postDoc" },
        { text: "فرصت‌های مطالعاتی", value: "opportune" },
        { text: "نخبگان وظیفه", value: "elite" },
        { text: "سایر", value: "other" },
      ],
    };
  },

  methods: {
    start() {
      // NOTE (m-start) to save drafts in each step
      this.$bvModal.show("loading");
      this.$http
        .post(
          this.baseUrl + "/setad/researcher/request/project/new",
          {
            initialObligation: this.initial.initialObligation,
            initialIsSupported: this.initial.initialIsSupported,
            initialSupportedType: this.initial.initialSupportedType,
            initialOtherSupport: this.initial.otherSupport,
            initialSupportDescription: this.initial.description,
            faSubject: this.initial.faSubject,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.$bvModal.hide("loading");
          const title = (
            <div>
              <h5>!ثبت پیشنویس</h5>
              <span>
                پیشنویس ثبت شد. برای ثبت نهایی تکمیل کلیه اطلاعات و زدن دکمه
                ارسال طرح الزامی است
              </span>
            </div>
          );
          this.toast(title, "info");

          this.$router.push("/researcher/completeProposal/" + res.data);
        })
        .catch((err) => {
          this.$bvModal.hide("loading");
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}

.color {
  background-color: #0c4961;
  color: white;
}
.required {
  color: red;
}

.done {
  color: green;
}
</style>
